"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Druid_1 = require("../../Druid");
class LoaderUI {
    static create() {
        var _a, _b;
        const anchor = document.createElement((_b = (_a = Druid_1.default.configuration().loader) === null || _a === void 0 ? void 0 : _a.template) !== null && _b !== void 0 ? _b : LoaderUI.tpl);
        const curtain = anchor.queryRole('curtain');
        const spinner = curtain.queryRole('spinner');
        return { anchor, curtain, spinner };
    }
}
LoaderUI.tpl = `
        <div class="dr-loader">
            <div class="curtain" data-role="curtain">
                <div class="spinner" data-role="spinner"></div>
            </div>
        </div>`;
exports.default = LoaderUI;
//# sourceMappingURL=LoaderUI.js.map